module.exports = require('stream');



//////////////////
// WEBPACK FOOTER
// ./~/readable-stream/lib/internal/streams/stream.js
// module id = 731
// module chunks = 0 1 2